import React, { FC, memo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { Box, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { TRACKING_METHOD_TYPE } from 'types/tracking'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { ILocationELD, IShipmentETA } from 'apps/fleet-planner/types'
import { ISubtitleComponentProps, ITitleComponentProps } from './ELDStates'
import { getBackgroundColor, getTitleColor, getTrackingMethodText } from './utils'

interface IShipmentMapFooter {
  /**
   * @example 'keep_truckin' or 'project_44'
   * @default 'mobile'
   */
  trackingMethod?: TRACKING_METHOD_TYPE
  alertType?: string
  recentLocations?: ILocationELD[]
  eta?: IShipmentETA
  TitleComponent: FC<ITitleComponentProps>
  SubtitleComponent: FC<ISubtitleComponentProps>
}

export const ShipmentMapFooter = memo<IShipmentMapFooter>(
  ({
    trackingMethod = TRACKING_METHOD_TYPE.fmsMobile,
    alertType = 'default',
    TitleComponent,
    SubtitleComponent,
    recentLocations,
    eta,
  }) => {
    const { trackEvent } = useFMSAnalytics()
    const history = useHistory()
    const { pathname } = useLocation()
    const trackingMethodText = getTrackingMethodText(trackingMethod as TRACKING_METHOD_TYPE)
    const openTrackingMethodModalHandler = () => {
      trackEvent('ELD', 'CLICKED_CHANGE_TRACKING_METHOD_ON_LOAD_DETAILS_MODAL')
      history.push(`${pathname}/tracking-method`)
    }

    return (
      <Box
        padding={2}
        style={{
          backgroundColor: getBackgroundColor(alertType),
        }}>
        <Box>
          <Typography
            variant='subtitle1'
            component='div'
            style={{
              color: getTitleColor(alertType),
            }}>
            <TitleComponent eta={eta} />
          </Typography>
        </Box>
        <Box>
          <Typography variant='subtitle2' component='div' style={{ color: brandColors.coolGray6 }}>
            <SubtitleComponent recentLocations={recentLocations} />
          </Typography>
        </Box>
        <Box pt={1}>
          <Typography
            variant='caption'
            component='span'
            style={{
              color: brandColors.coolGray6,
            }}>{`Tracking Method: ${trackingMethodText}.`}</Typography>{' '}
          <Button onClick={openTrackingMethodModalHandler} variant='text' noPadding>
            Change
          </Button>
        </Box>
      </Box>
    )
  }
)
